import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";

import { AutorizacionesCard } from "../UI/AutorizacionesCard";

import { AutorizacionesDetalleOrdenForm } from "./AutorizacionesDetalleOrdenForm";
import { AutorizacionesDetalleOrdenInformation } from "./AutorizacionesDetalleOrdenInformation";
import { getPracticasSolicitudSeleccionada } from "../../../actions/autorizaciones/Autorizaciones";
import { TIPOS_AUTORIZACIONES } from "../../../utils/constants";

export const AutorizacionesDetalleOrden = ({ permisoIngresoInterDom }) => {
  const dispatch = useDispatch();

  const { showForm, solicitudSeleccionada = {} } = useSelector(
    (state) => state.autorizaciones
  );

  let idTipoSolicitud;

  if (solicitudSeleccionada != null) {
    idTipoSolicitud = solicitudSeleccionada?.idTipoSolicitud;
  }
  if (!idTipoSolicitud || idTipoSolicitud === "") {
    idTipoSolicitud = TIPOS_AUTORIZACIONES.PRESUPUESTOS;
  }

  // console.log("soli", solicitudSeleccionada);
  // console.log("presu", presupuestoSeleccionado);
  // console.log("idTipoSolicitud", idTipoSolicitud);

  useEffect(() => {
    if (solicitudSeleccionada?.idSolicitud)
      dispatch(getPracticasSolicitudSeleccionada(solicitudSeleccionada.idSolicitud));
  }, [solicitudSeleccionada?.idSolicitud]);

  return (
    <AutorizacionesCard width={"55%"}>
      {showForm ? (
        <AutorizacionesDetalleOrdenForm
          permisoIngresoInterDom={permisoIngresoInterDom}
        />
      ) : (
        <AutorizacionesDetalleOrdenInformation
          idTipoSolicitud={idTipoSolicitud}
        />
      )}
    </AutorizacionesCard>
  );
};
